import {HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {CacheStore} from './cache-store';
import {RequestCache} from './request-cache';
import {RequestCacheEntry} from './request-cache-entry';

/**
 * A default implementation of a request cache.
 */
@Injectable()
export class DefaultRequestCache implements RequestCache {
    constructor(private cacheStore: CacheStore) {
    }

    get(req: HttpRequest<any>, maxAge: number): HttpResponse<any> | undefined {
        const cacheKey = this.determineKey(req);
        const cacheEntry = this.cacheStore.get(cacheKey);
        if (cacheEntry == null) {
            return undefined;
        }

        const isExpired = maxAge > 0 && cacheEntry.lastRead < (Date.now() - maxAge);
        const expired = isExpired ? 'expired ' : '';
        console.log(`Found ${expired}cached response for "${cacheKey}". max-age: ${maxAge}`);

        if (isExpired) {
            this.cacheStore.delete(cacheKey);
            return undefined;
        }

        // in some way the cacheEntry.response is not enough, therefore we create a new object of the class and
        // pass the response params.
        return new HttpResponse({
            body: cacheEntry.response.body,
            headers: cacheEntry.response.headers,
            status: cacheEntry.response.status,
            statusText: cacheEntry.response.statusText,
            url: cacheEntry.response.url
        });
    }

    put(req: HttpRequest<any>, response: HttpResponse<any>): void {
        const cacheKey = this.determineKey(req);
        console.log(`Caching response from "${cacheKey}".`);

        const entry: RequestCacheEntry = {
            response: response,
            lastRead: Date.now()
        };
        this.cacheStore.put(cacheKey, entry);
    }

    /**
     * Determines the cache key from a http request.
     *
     * @param req The http request.
     */
    protected determineKey(req: HttpRequest<any>): string {
        return req.urlWithParams;
    }
}
